import {Button,Dialog,DialogActions,DialogContent,DialogTitle, ListSubheader, MenuItem, Select} from "@mui/material";
import React, { useEffect } from "react";
import Loading from "../../../Loading";

import { net } from "../../../../../database";
import SelectFromList from "../../../components/SelectFromList";

import mut from "../../../hooks/mut";

export default function EditSyllabusDialog(props) {
    const { open, setOpen, lesson, update } = props;
  const [syl, setSyl] = React.useState(undefined);
  const [courseLesson, setCourseLesson] = React.useState(lesson.courseLesson);
    useEffect(() => { 
        if(open) {
           net.get("/get-syllabus-for-class/" + lesson.htClass).then((res) => {
             setSyl(res);
           });


        }
     
    }, [open, lesson.htClass]);
    if (!open) return null;
  if (open && !syl) return <Loading />;
console.log(syl)
  
  const updateServer = async () => { 
    let res = await mut("post",
      `/update-lesson-number/${lesson._id}`,
      { courseLesson }
    );
    update(res)
    setOpen(false);
  }
 
    const {syls,htc} = syl
  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>Update the syllabus</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            marginTop: 10,
          }}
        >
          <SelectFromList
            choices={syls}
            value={htc.syllabus}
            setValue={(syllabus) =>
              setSyl({ ...syl, htc: { ...htc, syllabus } })
            }
            label="Syllabus"
            url={"/update-class-syllabus/" + lesson.htClass}
            field="syllabus"
          />
          {/* <div style={{display:"flex", alignItems:"center", gap:10}}>
            <Text
              value={courseLesson}
              label="Course lesson"
              endAdornment="/80"
              type="number"
              setValue={setCourseLesson}
            />
            <div> / {syl.numberOfLessons ? syl.numberOfLessons : 80}</div>
          </div> */}
          {htc.syllabus && <ChooseLesson syllabus={syls.find(s => s._id === htc.syllabus)} value={courseLesson} setValue={setCourseLesson} />}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button color="success" onClick={updateServer}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}


function ChooseLesson({ syllabus, value, setValue }) {
  return (
    <Select
      value={value}
      onChange={(e) => {
        console.log(e.target.value);
        setValue(e.target.value);
      }}
    >
      {syllabus.units.flatMap((unit, i) => [
        <ListSubheader key={`header-${i}`}>
          {unit.unitNumber}. {unit.name}
        </ListSubheader>,
        ...unit.lessons.map((lesson, j) => (
          <MenuItem
            key={`lesson-${i}-${j}`}
            value={lesson.courseLessonNumber}
          >
            {lesson.lessonNumber}. {lesson.name}
          </MenuItem>
        )),
        <MenuItem
          key={`test-${i}`}
          value={unit.testLessonNumber}
        >
          Unit {unit.unitNumber} Test
        </MenuItem>,
      ])}
    </Select>
  );
}
